import { inventoryDuckCreator } from 'axl-ducks';

export default inventoryDuckCreator();
